import { IListItem } from '../../list-page/interfaces/interfaces';

import GridProduct from "../product/grid-product";
import React from "react";

interface IProductComparisonChartProps {
    skuNumber: string,
    product?: IListItem
}

const ProductComparisonChart = (props: IProductComparisonChartProps) => {

    //console.log('pcChart: ',pcChart);
    //const product = props.product as IListItem;

    return (
        <div className="compare-top mb-8">
            <GridProduct
                product={ props.product ?? {} as IListItem }
                isTaglineHidden={true}
                isButtonAndNoteHidden={false}
                isPriceFirstRowHidden={false}
                isPriceThirdRowHidden={false}
                isFirstMerchRowHidden={false}
                isPriceDiscountBadgeHidden={false}
                isPriceClockHidden={true}
                isExpectedShippingHidden={false}
                useSrcDetails={false}
                isRatingHidden={true}
            />

        </div>
    )
};

export default ProductComparisonChart;